"use client";

import { useSyncExternalStore } from "react";

export function useMediaQuery(query: string, defaultValue = true): boolean {
  return useSyncExternalStore(
    (callback) => {
      const mql = window.matchMedia(query);
      mql.addEventListener("change", callback);
      return () => mql.removeEventListener("change", callback);
    },
    () => window.matchMedia(query).matches,
    () => defaultValue,
  );
}
